import { FC } from "react";

import { TaskDriverStatusEnum } from "@/domain/models/common";
import { formatBinSize } from "@/src/utils/strings";

import { useUpdateServiceMutation } from "../data/mutations/serviceMutations";
import { useUpdateTaskMutation } from "../data/mutations/taskMutations";
import { useTaskQuery } from "../data/queries/taskQueries";
import { JobServiceTaskBaseType } from "../domain/task";
import { DriverStepScreenWrapper } from "./DriverStepScreenWrapper";

const DriverPickUpBinOnSite: FC<JobServiceTaskBaseType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  const { data: taskData } = useTaskQuery({ jobId, serviceId, taskId });

  const {
    mutate: updateService,
    isPending: isUpdatingService,
    variables,
  } = useUpdateServiceMutation();
  const { mutate: updateTask, isPending: isUpdatingTask } =
    useUpdateTaskMutation();

  const onNextClick = () => {
    updateService({
      serviceId,
      jobId,
      driverFlowStatus: TaskDriverStatusEnum.CATEGORIZE_BIN_CONTENTS,
    });

    updateTask({
      jobId,
      serviceId,
      taskId,
      driverFlowStatus: TaskDriverStatusEnum.CATEGORIZE_BIN_CONTENTS,
    });
  };

  const isLoading = isUpdatingService || isUpdatingTask;

  const isNextButtonLoading =
    isLoading &&
    variables?.driverFlowStatus ===
      TaskDriverStatusEnum.CATEGORIZE_BIN_CONTENTS;

  const isPreviousButtonLoading =
    isLoading &&
    variables?.driverFlowStatus ===
      TaskDriverStatusEnum.TAKING_PHOTO_DROPPED_BIN;

  const goToPreviousStep = () => {
    updateService({
      jobId,
      serviceId,
      driverFlowStatus: TaskDriverStatusEnum.TAKING_PHOTO_DROPPED_BIN,
    });

    updateTask({
      jobId,
      serviceId,
      taskId,
      driverFlowStatus: TaskDriverStatusEnum.TAKING_PHOTO_DROPPED_BIN,
    });
  };

  return (
    <DriverStepScreenWrapper
      jobId={jobId}
      serviceId={serviceId}
      taskId={taskId}
      title="driver_pick_up_bin_on_site.title"
      titlei18nOptions={{
        binIdentifier: taskData?.connectedTask?.assignedBin?.identifier,
        binSize: formatBinSize(taskData?.connectedTask?.assignedBin?.size),
      }}
      isNextButtonLoading={isNextButtonLoading}
      onNextButtonClick={onNextClick}
      previousButtonTitle="driver_pick_up_bin_on_site.back_button"
      onPreviousButtonClick={goToPreviousStep}
      isPreviousButtonLoading={isPreviousButtonLoading}
    />
  );
};

export { DriverPickUpBinOnSite };
